import { apiClient } from '@/services/ApiClient.js'

export class RelatedPostService {
  getRelatedPosts(post) {
    return apiClient
      .get('posts/' + post + '/related-posts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createRelatedPost(post, relatedPosts) {
    return apiClient
      .post('posts/' + post + '/related-posts', relatedPosts)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateRelatedPost(post, relatedPosts) {
    return apiClient
      .patch('posts/' + post + '/related-posts', relatedPosts)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  deleteRelatedPost(post, relatedPost) {
    return apiClient
      .delete('posts/' + post + '/related-posts/' + relatedPost)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
